import React from 'react';
import { Drawer, DrawerHeader } from '@noths/polaris-client-ribbons-design-system';
import { Button } from '@noths/polaris-design-system-core-components';

import { FacetOptionsMulti } from 'src/components/organisms/ListingsControlsOptions/FacetOptionsMulti';
import { FacetOptionsSingle } from 'src/components/organisms/ListingsControlsOptions/FacetOptionsSingle';
import type { UIFacet } from 'src/components/types/UIFacet';
import * as styles from './FacetDrawer.styles';

export interface FacetDrawerProps {
  ctaText: string;
  facet: UIFacet | null;
  isOpen: boolean;
  loading: boolean;
  onAfterClose?: () => void;
  onClose: () => void;
}

export const FacetDrawer = ({
  ctaText,
  facet,
  isOpen,
  loading,
  onAfterClose,
  onClose,
}: FacetDrawerProps) => {
  const FacetOptionsComponent = facet?.type === 'single' ? FacetOptionsSingle : FacetOptionsMulti;

  return (
    <Drawer
      contentContainerStyles={styles.drawerRoot}
      contentLabel={facet ? `${facet.title} filter options` : 'Filter options'}
      isOpen={isOpen}
      onAfterClose={onAfterClose}
      onOverlayClick={onClose}
      onRequestClose={onClose}
      panelSize="full"
      transitionFrom="bottom"
    >
      {facet && (
        <>
          <div css={styles.drawerHeader}>
            <DrawerHeader headingLevel="h2" onClose={onClose} title={facet.title} />
          </div>
          <div css={styles.drawerBody}>
            <FacetOptionsComponent facet={facet} />
          </div>
          <div css={styles.drawerFooter}>
            <Button fullWidth onClick={onClose}>
              {loading ? 'Updating...' : ctaText}
            </Button>
          </div>
        </>
      )}
    </Drawer>
  );
};
